module.exports = __webpack_public_path__ + "img/damian-patkowski-T-LfvX-7IVg-unsplash.3cd4864b.jpg";